<template>
  <div>
    <button
      @click="$emit('click')"
      type="button"
      style="z-index: 10"
      class="inline-flex items-center px-2 sm:px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-teal-700 focus:shadow-outline-teal active:bg-green-700 transition ease-in-out duration-150"
    >
      <font-awesome-icon
        icon="shopping-cart"
        class="fa-fw nav-icon mr-1"
      ></font-awesome-icon>
      {{ order.order_items.length }}
      <div v-if="order.order_items.length" class="ml-2">
        Checkout Now &raquo;
      </div>
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "CartButton",

  data() {
    return {};
  },
  methods: {},
  computed: {
    order: function () {
      return this.$store.getters["order/getOrder"];
    },
  },
  mounted() {},
};
</script>

<style scoped>
button {
  /*position: absolute;*/
  /*top: 10px;*/
  /*right: 10px;*/
}
</style>
